import React, { useEffect, useState } from "react";
import { Col, Row, Container, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import { getProductList } from "../../../actions/Book.action";
import LoadPortFolio from "../LoadPortFolio/LoadPortFolio";

import styles from "./LoadProductPortfolios.module.css";

const LoadProductPortfolios = ({ data, getProductList }) => {
  useEffect(() => {
    if (!data) {
      getProductList();
    }
  }, []);
  return (
    <main>
      <div className="m-5"></div>
      <div className="mb-2">
        <div className={styles.headline}>
          <h1 className="my-3 mx-3">Products</h1>
        </div>
        <Container>
          {!data ? (
            <div className="py-5">
              <Spinner variant="dark" />
            </div>
          ) : (
            <Row>
              {data.map((item) => (
                <Col md={6} lg={3} key={item._id} className="mb-4">
                  <LoadPortFolio data={item} service={"Products"} />
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </div>

      <div className="m-5"></div>
    </main>
  );
};
const mapStateToProps = (state) => ({
  data: state.product.product,
});
export default connect(mapStateToProps, { getProductList })(
  LoadProductPortfolios
);
